import { useCallback } from 'react'

import { useLocation, useNavigate } from 'react-router'

// ///////////////////////
// MARK: EXPORTS
export function useNavigateGoBack(): () => void {
  const location = useLocation()
  const navigate = useNavigate()

  return useCallback(() => {
    if (window.history.length <= 1) {
      navigate(location.pathname.split('/').slice(0, -1).join('/'), {
        replace: true,
      })
    } else {
      navigate(-1)
    }
  }, [location.pathname, navigate])
}
